import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ServicePlanCategory } from 'src/features/servicePlanCategory/utils/types';

const RESOURCE = '/subscriptions/service-plan-category/:id/';

type QueryFnType = typeof queryFn;

interface DTO {
    id: string;
}
const queryFn = ({ id }: DTO): Promise<ServicePlanCategory> => {
    return axios.get(formatResourcePath(RESOURCE, { id }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetServicePlanCategory,  RESOURCE as SERVICE_PLAN_CATEGORY_RESOURCE };
